import React from 'react';
import { Link } from 'react-router-dom';
import { heroImage, systemPoints } from '../data/mock';
import { Check, ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section id="home" className="relative">
      <div className="relative w-full h-[280px] sm:h-[400px] lg:h-[520px] overflow-hidden">
        <img
          src={heroImage}
          alt="Yoga mat, dumbbells and water bottle flat lay"
          className="w-full h-full object-cover"
          loading="eager"
        />
        {/* Dark scrim so headline stays legible in every light condition */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0c] via-[#0b0b0c]/60 to-transparent" />
      </div>

      <div className="bg-[#0b0b0c] relative">
        <div className="max-w-[1180px] mx-auto px-5 lg:px-8 pt-8 pb-16 lg:pt-14 lg:pb-24 grid lg:grid-cols-[1.2fr_1fr] gap-10 lg:gap-14">
          <div>
            <p className="text-[10px] font-mono uppercase tracking-[0.22em] font-black text-[#BEFF38]">
              The AI fitness tutor
            </p>
            <h1
              className="mt-3 text-white font-black leading-[0.95] tracking-tight uppercase text-5xl sm:text-6xl lg:text-7xl"
              style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
            >
              Adapts as your<br />body does.
            </h1>
            <p className="mt-6 text-zinc-300 text-base sm:text-lg leading-relaxed max-w-xl">
              Personalised training, nutrition and recovery that dynamically responds to your injuries, equipment, goals, progress and recovery.
            </p>
            <p className="mt-3 text-zinc-500 text-sm leading-relaxed max-w-xl">
              Set your target. Check in weekly. Follow your daily call — FreeFitFuel adjusts as real life gets in the way.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/my-plan?tab=profile&sub=plan"
                data-testid="hero-build-plan-cta"
                onClick={() => { try { import('../lib/analytics').then(m => m.trackSignupStart('hero_build')); } catch { /* noop */ } }}
                className="group inline-flex items-center gap-1.5 px-6 py-3.5 rounded-full bg-[#BEFF38] text-black font-black text-xs uppercase tracking-widest hover:bg-[#a8e62e] transition-colors shadow-[0_4px_20px_rgba(190,255,56,0.25)]"
              >
                Build My Plan
                <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" strokeWidth={2.5} />
              </Link>
              <Link
                to="/my-plan"
                data-testid="hero-start-today-cta"
                onClick={() => { try { import('../lib/analytics').then(m => m.trackSignupStart('hero_start')); } catch (e) {} }}
                className="inline-flex items-center px-6 py-3.5 rounded-full bg-transparent border border-zinc-700 text-white font-black text-xs uppercase tracking-widest hover:border-white transition-colors"
              >
                Start Today
              </Link>
            </div>
            <p className="mt-4 text-zinc-500 text-xs">One adaptive system · Training · Nutrition · Recovery · Coaching</p>
          </div>

          <aside className="self-end lg:self-center w-full">
            <div className="rounded-2xl border border-zinc-800 bg-zinc-950/60 backdrop-blur p-6 lg:p-7">
              <p className="text-[10px] font-mono uppercase tracking-[0.22em] font-black text-[#BEFF38]">What the system does</p>
              <ul className="mt-4 space-y-3">
                {systemPoints.map((p) => (
                  <li key={p} className="flex gap-3 text-zinc-300 text-sm leading-snug">
                    <Check className="w-4 h-4 text-[#BEFF38] mt-0.5 shrink-0" strokeWidth={2.5} />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};

export default Hero;
